/**
 * 로그인 후 돌아갈 내부 경로만 허용한다.
 * 외부 URL이나 인증 화면으로 다시 들어가는 루프는 버린다.
 */
const AUTH_LOOP_PATHS = [
  '/login',
  '/signup',
  '/oauth',
  '/find-id',
  '/find-password',
  '/admin/login',
]

export function safeMemberRedirect(raw: unknown, fallback = '/'): string {
  if (typeof raw !== 'string') return fallback

  const value = raw.trim()
  if (!value.startsWith('/') || value.startsWith('//') || value.includes('://')) {
    return fallback
  }

  const pathname = value.split(/[?#]/)[0]
  const isAuthLoop = AUTH_LOOP_PATHS.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
  if (isAuthLoop) return fallback

  return value
}

export function memberLoginTo(redirect: string) {
  const safe = safeMemberRedirect(redirect, '')
  return safe ? { path: '/login', query: { redirect: safe } } : { path: '/login' }
}
